import { fetchListDetails } from '../../Services/PropertyListService'
import { getQueryStringValue } from '../../../PropertySearch/Utility/Utility'
import { rentCompAvgCalc, determineDistanceFromSubject } from '../PropertyListUtility'

class GetListDetails {
    constructor(listIds, setPropertyList, setShowSpinner, reloadFlag = true) {
        this.listId = listIds.polarisPropertySearchCriteriaId
        this.ov_listId = listIds.omniViewPropertyListId
        this.setPropertyList = setPropertyList
        this.setShowSpinner = setShowSpinner
        this.reloadFlag = reloadFlag
    }

    createPayload() {

        let payload = {
            "listDetails": {
                'polarisPropertySearchCriteriaId': this.listId,
                'omniViewPropertyListId': this.ov_listId
            },
            "reloadFlag": this.reloadFlag
        }

        return payload
    }

    addCustomFields(compsList) {

        compsList.forEach(item => {
            item.excludeProperty = false
            item.sortBy = ''
            item.sortOrder = ''
            item.data.omniViewPropertyListId = item.data.omniViewPropertyListId ? item.data.omniViewPropertyListId : ''
            item.data.polarisPropertySearchCriteriaId = item.data.polarisPropertySearchCriteriaId ? item.data.polarisPropertySearchCriteriaId : ''
        })

        return compsList
    }

    unitMixDataCorrection(compsList) {
        try {
            compsList.forEach(item => {
                if (item.data && item.data.omniviewpropertyrent && item.data.omniviewpropertyrent.length > 0) {
                    item.data.omniviewpropertyrent.forEach(element => {
                        try {
                            let source = element['source'] ? element['source'] : ''
                            source = source.toLowerCase()
                            if (source === 'bcm') {
                                source = 'BCM'
                            }
                            if (source === 'axio') {
                                source = 'Axio'
                            }
                            if (source === 'yardi') {
                                source = 'Yardi'
                            }
                            element['source'] = source

                            if (element && element['unitType'] && element['unitType'] === 'Studio') {
                                element['unitType'] = '0 Bedroom/1 Bath'
                            }
                        } catch (error) {
                            console.log(' error in  unitMixDataCorrection:: ', error)
                        }
                    });
                }
            })
        } catch (error) {
            console.log(' unitMixDataCorrection in  :: ', error)
        }

        return compsList
    }

    defaultCalc(propertyList) {
        rentCompAvgCalc({ ...propertyList }, this.setPropertyList)
    }

    async fetchResult() {
        const payload = this.createPayload()

        const response = await fetchListDetails(payload)
        // console.log('response:::', response.data)
        this.setShowSpinner(false)
        if (response && response.status === 200) {

            let compsList = [...response.data.data[0].compsList]

            let missingPropertyIds = []
            compsList.forEach(element => {
                if (!element.data.omniviewproperty) {
                    missingPropertyIds.push(element.omniViewPropertyId)
                }
            });
            compsList = compsList.filter(x => !missingPropertyIds.includes(x.omniViewPropertyId))

            compsList = [...this.addCustomFields(compsList)]

            compsList = [...this.unitMixDataCorrection(compsList)]

            compsList = [...determineDistanceFromSubject(compsList)]

            let subjectProperties = compsList.filter(x => x.isSubjectProperty)
            let nonSubjectProperties = compsList.filter(x => !x.isSubjectProperty)

            nonSubjectProperties = nonSubjectProperties.sort(function (a, b) {
                return a.rank - b.rank
            })

            subjectProperties = subjectProperties.sort(function (a, b) {
                return a.rank - b.rank
            })

            response.data.data[0].showReno = true
            response.data.data[0].showCAP = true
            response.data.data[0].showGRM = true
            response.data.data[0].showBuyerSeller = true
            response.data.data[0].compType = response.data.data[0].compType ? response.data.data[0].compType : 'Rent'

            // response.data.data[0].showUnitMix = true
            // response.data.data[0].showPhoto = true

            response.data.data[0].compsList = [...subjectProperties, ...nonSubjectProperties]

            this.setPropertyList(response.data.data[0])

            // console.log('list Details:::', response.data.data[0])

            this.defaultCalc(response.data.data[0], this.setPropertyList)

            const omniViewUserId = getQueryStringValue('userId')
            const list_id = response.data.data[0].polarisPropertySearchCriteriaId
            const list_ov_id = response.data.data[0].omniViewPropertyListId

            window.history.pushState({}, 'Property List', `/PropertyList?userId=${omniViewUserId}&view=lists&list_id=${list_id}&list_ov_id=${list_ov_id}`)
        }

    }

}

export default GetListDetails
